import { FC, memo } from "react";
import { OverlayTrigger } from "react-bootstrap";

import { renderTooltip } from "../../StyledTooltip/StyledTooltip";

interface IProps {
  name: string;
  state: "pending" | "ready" | "paused" | "suspended" | "unsubscribed";
}

const keyStates = {
  ready: {
    className: "ready",
    tooltip: "Ready to use",
  },
  unsubscribed: {
    className: "unsubscribed",
    tooltip: "Disabled, no active subscription",
  },
  suspended: {
    className: "suspended",
    tooltip: "Disabled, no active subscription",
  },
  paused: {
    className: "suspended",
    tooltip: "Temporarily disabled",
  },
  pending: {
    className: "suspended",
    tooltip: "Disabled, no active subscription",
  },
};
const KeyNameColumn: React.FC<IProps> = memo(({ name, state }) => {
  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={renderTooltip(keyStates[state].tooltip)}
      >
        <span
          className={`key-status-indicator ${keyStates[state].className}`}
        />
      </OverlayTrigger>

      <span>{name}</span>
    </>
  );
});

export { KeyNameColumn };
